module.exports = __webpack_public_path__ + "img/ng_1.0abc7e03.png";